import { request } from '@/utils/request';

const urls = {
  list: '/api/templateMockApi/basic-list/list', // 列表
  delete: '/api/templateMockApi/basic-list/delete', // 删除
  add: '/api/templateMockApi/basic-list/add', // 添加
  detail: '/api/templateMockApi/basic-list/detail', // 详情
  timeLine: '/api/templateMockApi/basic-list/timeLine', // 流转日志
};

export async function reqList (params) {
  return request(urls.list, {
    params,
  });
}

export async function reqDelete (params) {
  return request(urls.delete, {
    params,
  });
}

export async function reqDetail (params) {
  return request(urls.detail, {
    params,
  });
}

export async function reqTimeLine (params) {
  return request(urls.timeLine, {
    params,
  });
}

export async function reqAdd (params) {
  return request(urls.add, {
    params,
  });
}
